import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-grids";
import { Observable, Subject } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { GetICD10BO } from "./icd10.model";

@Injectable({
  providedIn: 'root'
})

export class ICD10Service extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService, public errorService: ErrorService) {
    super();
  }

  public execute(state: GetICD10BO): void {
    this.getICD10Codes(state).subscribe(x => super.next(x));
  }

  getICD10Codes(state?: GetICD10BO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ICD10/GetAgencyICD10Codes", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['icD10List'],
            count: response['totalCount']
          }
      ))
  }
}